<template>
    <div>
        <transition name="fade">
            <div
                class="popup"
                v-if="popupVisible"
            >
                <div
                    class="popup__bg"
                    @click="hidePopup"
                />
                <div class="popup__inner">
                    <button
                        class="popup__close"
                        @click="hidePopup"
                    >
                        <i class="icon-close" />
                    </button>

                    <div class="responsive-embed widescreen">
                        <iframe
                            width="560"
                            height="315"
                            src="https://www.youtube.com/embed/9ipPio0LdhA?autoplay=1&rel=0"
                            frameborder="0"
                            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen
                        />
                    </div>
                    
                    <div class="popup__caption">
                        Nog niet geholpen? Stel dan je vraag via <a href="mailto:ijstijd@knsb.nl">ijstijd@knsb.nl</a>.
                    </div>
                </div>
            </div>
        </transition>

        <button
            class="btn btn--white btn--float"
            @click.prevent="showPopup"
        >Hulp nodig?</button>
    </div>
</template>

<script>
export default {
    data() {
        return {
            popupVisible: false
        }
    },
    methods: {
        showPopup() {
            this.popupVisible = true;
        },
        hidePopup() {
            this.popupVisible = false;
        }
    }
};
</script>
